import { FC } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import CustomIcon from '@components/utils/CustomIcon';
import { CloseIcon, FilterIcon, TrashIcon } from '@assets/icons';

import {
  Button,
  ClearAllFiterWrapper,
  NonCollapsableFilterContainer,
  NonCollapsableFilterLeftItems,
  NonCollapsableFilterLeftText,
  NonCollapsableFilterRightItems,
  NonCollapsableFilterRightText,
  ClearAllFiltersCard,
} from './styled';

interface Props {
  text?: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: 'default' | 'card';
}

const ClearAllFilters: FC<Props> = ({
  text = 'Tümünü Temizle',
  onClick,
  disabled,
  variant = 'default',
}) => {
  const { xl } = useBreakpoint();
  if (variant === 'card') {
    return (
      <ClearAllFiltersCard onClick={onClick} disabled={disabled}>
        <CustomIcon icon={CloseIcon} fontSize={18} paletteColor='grey1100' />
        {text}
      </ClearAllFiltersCard>
    );
  }

  return xl === undefined || xl ? (
    <ClearAllFiterWrapper>
      <h6>Filtreler</h6>
      <Button onClick={onClick} disabled={disabled}>
        {text}
      </Button>
    </ClearAllFiterWrapper>
  ) : (
    <NonCollapsableFilterContainer>
      <NonCollapsableFilterLeftItems>
        <CustomIcon fontSize={24} paletteColor='grey500' icon={FilterIcon} />
        <NonCollapsableFilterLeftText>Filtrele</NonCollapsableFilterLeftText>
      </NonCollapsableFilterLeftItems>
      <NonCollapsableFilterRightItems onClick={onClick} disabled={disabled}>
        <NonCollapsableFilterRightText>
          Tüm Filtreleri Temizle
        </NonCollapsableFilterRightText>
        <CustomIcon fontSize={20} paletteColor='eclipse' icon={TrashIcon} />
      </NonCollapsableFilterRightItems>
    </NonCollapsableFilterContainer>
  );
};

export default ClearAllFilters;
